
import { defineStore } from 'pinia'
import CteService from '@/modules/cte/services/cte-service'
import A3Service from '../../../services/a3-service'
import ErpService from '@/modules/cte/services/erp-service'

import router from '@/shared/router'
import Vue from 'vue'
import { formataMoeda, removeMoeda } from '@/shared/common/functions/numero'
import { isMobile } from '@/shared/common/functions/interface'

export const useListaStore = defineStore('ListaCte', {
    state: () => ({
        cteApiUrl: process.env.VUE_APP_API_CTE_URL || 'https://cte.beteltecnologia.net/',
        usuarioLogado: {},
        dSituacaoBuscaAvancada: false,
        filtros: {
            periodoDe: '',
            periodoAte: '',
        },
        paginacao: {
            currentPage: 1,
            firstPage: 1,
            to: 0,
            from: 0,
            lastPage: 0,
            perPage: 0,
            total: 0
        },

        tableFields: [
            {
                key: 'selecionado',
                label: '',
                thClass: 'd-none', 
                tdClass: 'd-none',
                thStyle: { width: '15px', textAlign: 'center' }
            },
            {
                key: 'ide_nct',
                label: 'Nº',
                sortable: true
            },
            {
                key: 'ide_serie',
                label: 'Série',
                sortable: true,
                class: 'd-none d-sm-table-cell'
            },
            {
                key: 'cadastrado_em',
                label: 'Data/hora',
                sortable: true,
                class: 'd-none d-sm-table-cell'
            },
            {
                key: 'ide_xmunini',
                label: 'Início da prestação',
                sortable: true,
                class: 'd-none d-sm-table-cell'
               
            },
            {
                key: 'ide_xmunfim',
                label: 'Término da prestação',
                sortable: true,
                class: 'd-none d-sm-table-cell'
            },
            {
                key: 'rem.xnome',
                label: 'Remetente',
                sortable: true,
                class: 'd-none d-sm-table-cell'
            },
            {
                key: 'dest.xnome',
                label: 'Destinatário',
                sortable: true,
            },
            {
                key: 'situacao',
                label: 'Situação',
                sortable: true,
                thStyle: { textAlign: 'center' },
                tdClass: 'text-center',
                class: 'd-none d-sm-table-cell'
            },
            {
                key: 'acoes',
                label: 'Ações',
                class: 'text-center',
                thStyle: { width: '140px' },
            }
        ],
        tableItems: [],
        listaVazia: {
            icone: 'fa-archive',
            titulo: 'Conhecimentos de transporte',
            descricao:
                'Faça a gestão e emissão de documentos essenciais para o transporte de mercadorias. Esse módulo é projetado para facilitar o controle logístico e regulatório, permitindo que empresas registrem as informações relevantes sobre o transporte de carga. Isso inclui dados sobre a origem e o destino, detalhes do carregamento, identificação do transportador, informações sobre a carga e outros elementos necessários para cumprir as exigências legais e acompanhar o transporte de maneira eficiente.',
            botoes: [
                {
                    variant: 'success',
                    link: `${Vue.prototype.$urlBase}/conhecimentos/adicionar`,
                    icone: 'fa-plus-circle',
                    texto: 'Adicionar conhecimento'
                },
                {
                    variant: 'primary',
                    link: `${Vue.prototype.$urlBase}/conhecimentos/importar-xml`,
                    icone: 'fa-cloud-upload',
                    class: 'd-none d-md-inline-flex',
                    texto: 'Importar meus conhecimentos'
                }
            ],
            tituloLista: 'Adicionando conhecimentos você vai conseguir:',
            lista: [
                'Emitir conhecimentos',
                'Armazenar os XML dos conhecimentos',
                'Enviar a DACTE para os clientes e fornecedores via e-mail',
                'Imprimir a DACTE',
                'Baixar os XMLs dos conhecimentos',
                'Obter histórico de conhecimentos',
                'Cancelar conhecimentos',
                'E muito mais...'
            ]
        },
        checkboxSelecionaTodos: false,
        carregado: false,
        carregadoExportarXml: true,
        options: {},
        permissions: [],
        form: {
            compartilhaWhatsapp: {
                celular: '',
                mensagem: ''
            },
            exportarXmls: {
                loja: '',
                data_inicio: '',
                data_fim: '',
                numero: ''
            },
            cancelarConhecimento: {
                id: '',
                motivo: ''
            },
            enviaEmail: {
                emails: '',
                responderPara: Vue.prototype.$usuarioLogado.email,
                assunto: '',
                mensagem: '',
                link: '',
                linkTitle: 'Copiar link',
            },
            pagamento: {
                exibirPagamento: 1,
                opcaoPagamento: '',
                formaPagamentoId: '',
                formaPagamentoNome: '',
                intervaloParcelas: '',
                quantidadeParcelas: '',
                dataPrimeiraParcela: '',
                pagamentoParcela: [],
                valorTotal: ''
            },
        },
        controle: {
            pagamento: {
                carregado: false,
                quantidadeParcelas: 'input',
                condicoesPagamentos: [],
                configPagamento: {
                    maximoParcelas: 1,
                    formaPagamentoAtual: 0,
                    categoriaAtual: 0,
                    formasPagamento: [],
                    mostraFormasPagamento: {},
                    categoria: {
                        CategoriasMovimentacoesFinanceira: {}
                    },
                    permissaoCadastrarFormaPagamento: 1,
                    permissaoCadastrarCategoria: 1
                },
                inf: {
                    conhecimentoId: '',
                    cliente: '',
                    descricao: '',
                    valor: 0
                }
            }, 
            
        }
    }),
    getters: {
        selecionados: (state) => state.conhecimentos.filter((item) => item.selecionado),

        /* MODAL GERAR FINANCEIRO (PAGAMENTO) */
        quantidadeParcelas: function () {
            const lista = []
            let i = 0
            while (i < this.controle.pagamento.configPagamento.maximoParcelas) {
                i++
                lista.push({
                    value: i,
                    text: i + ' ' + (i == 1 ? 'vez' : 'vezes')
                })
            }
            
            return lista
        },
    },
    actions: {

        abreAdicionarCte(){
            if(!this.verificaPermissao('conhecimentos/adicionar')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }
            location.href = `${Vue.prototype.$urlBase}/conhecimentos/adicionar`
        },

        abreEditarCte(id, situacao) {
            if(!this.permiteEdicao(situacao)){
                Vue.prototype.$notify.error('Esse CT-e já foi emitido e não pode ser editado!');
                return;
            }

            if(!this.verificaPermissao('conhecimentos/editar')) {
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            location.href = `${Vue.prototype.$urlBase}/conhecimentos/editar/${id}?retorno=${this.urlRetornoFormatada()}`
        },
        
        async exportarExcel() {

            if(!this.verificaPermissao('conhecimentos/exportar-xls')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const selecionados = this.tableItems.filter(item => item.selecionado)

            if (selecionados.length == 0) {
                Vue.prototype.$dialog.warning(`Você deve selecionar no mínimo um registro.`)
                return false
            }
          
            const retorno = await CteService.exportarExcel(selecionados)

            if (retorno.status == 200) {

                const link = 'data:application/xlsx;base64,' + retorno.data.conteudo
                const download = document.createElement('a')
                const fileName = retorno.data.arquivo
                download.href = link
                download.download = fileName
                download.click()

                Vue.prototype.$dialog.success(`Conhecimentos exportadas com sucesso!`)
                
            } else {
                
                Vue.prototype.$dialog.error(retorno.message)
            }
        },

        importarXml(){

            if(!this.verificaPermissao('conhecimentos/importar-xml')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }
            location.href = `${Vue.prototype.$urlBase}/conhecimentos/importar-xml`
        },
        
        async selecionaRegistro(index) {

            this.tableItems[index].selecionado = !this.tableItems[index].selecionado
            if (this.tableItems.some((item) => item.selecionado == false)) {
                this.checkboxSelecionaTodos = false
            }
            if (this.tableItems.every((item) => item.selecionado == true)) {
                this.checkboxSelecionaTodos = true
            }
        },

        selecionaTodos() {
            
            this.tableItems.map((item) => (item.selecionado = this.checkboxSelecionaTodos))
        },

        mounted(usuarioLogado){

            this.usuarioLogado = usuarioLogado;
            this.inicializarFiltros();
        },
        async deleta(route, item) {

            if(!this.verificaPermissao('conhecimentos/excluir')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const deletar = await Vue.prototype.$dialog.delete(
                `Deseja realmente excluir o conhecimento <span class="font-weight-bold">Nº ${item.ide_nct}</span>?`
            )
            if (deletar) {

                const retorno = await CteService.remover(item.id)

                if (retorno.status == 204) {
                    Vue.prototype.$notify.success('Conhecimento removido com sucesso!')
                    this.carregaDados(route)
                }
            }

        },

        async excluirSelecionados() {
            if(!this.verificaPermissao('conhecimentos/excluir')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const cteSelecionados = this.tableItems.filter(item => item.selecionado)

            if (cteSelecionados.length == 0) {
                Vue.prototype.$dialog.warning(`Você deve selecionar no mínimo um registro.`)
                return false
            }

            cteSelecionados.forEach((item) => {
                if(item.situacao != 'Em aberto'){
                    Vue.prototype.$dialog.warning('Apenas conhecimentos com a situação Em aberto podem ser removidos.')
                    return false
                }
            })

            const confirmacao = await Vue.prototype.$dialog.confirm('Deseja realmente excluir os conhecimentos selecionados?', { icon: 'text-danger glyphicon glyphicon-trash' })

            if (confirmacao) {
                cteSelecionados.forEach(async (item) => {
                    await CteService.remover(item.id)
                    const index = this.tableItems.indexOf(item)
                    this.tableItems.splice(index, 1)
                })

                this.$notify.success('Conhecimento(s) removido(s) com sucesso!')
            }
        },

        async exportarXml(){

            if(!this.verificaPermissao('conhecimentos/exportar-xmls')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            await Vue.prototype.$modal.show(() => import('../components/Modals/ExportarXml.vue'), 'md')
            
        },
        async paginando(page){

            this.filtros.page = page;
            this.alteraRouter();
        },
        verificaPermissao(permission){
            for (let i = 0; i < this.permissions.length; i++) {
                if (this.permissions[i][permission] !== undefined) {
                    return this.permissions[i][permission];
                }
            }
            return false;
        },
        async imprimirDacte(id){

            if(!this.verificaPermissao('conhecimentos/imprimir-dacte')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            window.open(`${Vue.prototype.$urlBase}/conhecimentos/dacte/${id}`, '_blank');
    
        },
        async carregaDados(route = null) {

            if(route) {
                this.inicializarFiltros(route.query);
            }

            this.carregado = false;
            const ret = await CteService.listar(route?.query)

            if (ret.status == 200) {

                ret.data.items = ret.data.items.map(item => {
                    switch (item.situacao) {
                        case 'Em aberto': return { classe_situacao: 'muted', ...item };
                        case 'Reprovado': return { classe_situacao: 'danger', ...item };
                        case 'Autorizado': return { classe_situacao: 'success', ...item };
                        case 'Denegado': return { classe_situacao: 'danger', ...item };
                        case 'Cancelado': return { classe_situacao: 'danger', ...item };
                    }
                });

                ret.data.items = ret.data.items.map(item => {
                    return { ...item, selecionado: false };
                })
                
                this.tableItems = ret.data.items;

                this.paginacao = {
                    currentPage: ret.data.current_page,
                    firstPage: ret.data.first_page,
                    to: ret.data.to,
                    from: ret.data.from,
                    lastPage: ret.data.last_page,
                    perPage: ret.data.per_page,
                    total: ret.data.total
                }
                this.options = ret.data.options;
                this.permissions = ret.data.permissions;
                this.options.lojas = this.usuarioLogado.UsuarioLojas.map(item => {
                    return {
                    text: item.Loja.nome,
                    value: item.UsuariosLoja.loja_id
                    };
                });
                
                const req = await ErpService.getCategoriaPadrao('PS')
                this.controle.pagamento.configPagamento.categoria.CategoriasMovimentacoesFinanceira = req.data.CategoriasMovimentacoesFinanceira

                this.carregado = true;

            } else {
                Vue.prototype.$notify.error(ret.message)
                location.href = `${Vue.prototype.$urlBase}/sistema/inicio`
            }

        },
        async atualizaDataInicio(data){
            this.filtros.periodoDe = data
        },
        async atualizaDataFim(data){
            this.filtros.periodoAte = data
        },
        alternarBuscaAvancada(){
            this.dSituacaoBuscaAvancada = !this.dSituacaoBuscaAvancada
        },
        inicializarFiltros(query = {}){
            
            if(query?.situacaoBuscaAvancada) {
                this.dSituacaoBuscaAvancada = true;
            }

            this.filtros = {
                loja: this.usuarioLogado.Loja.id,
                nCT: query?.nCT || '',
                serie: query?.serie || '',
                periodoDe: query['periodoDe'] !== undefined ? query['periodoDe'] : Vue.prototype.$moment().startOf('month').format('DD/MM/YYYY'),
                periodoAte: query['periodoAte'] !== undefined ? query['periodoAte'] : Vue.prototype.$moment().endOf('month').format('DD/MM/YYYY'),
                situacao: query?.situacao || '',
                tpCTe: query?.tpCTe || '',
                tpServ: query?.tpServ || '',
                tpEmis: query?.tpEmis || '',
                remetente: query?.remetente || '',
                destinatario: query?.destinatario || '',
                expedidor: query?.expedidor || '',
                recebedor: query?.recebedor || '',
                tomador: query?.tomador || '',
                page: query?.page
            };
        },
        limpaBuscaAvancada(route){    

            location.href = `${route.path}?situacaoBuscaAvancada=true`
        },
        async enviarBuscaAvancada(){
           
            this.filtros['situacaoBuscaAvancada'] = true
            this.alteraRouter();
        },

        async alteraRouter(){

            let _parametros = Object.assign({}, this.filtros)
            Object.keys(_parametros).map(parametro => {
                if(_parametros[parametro] && typeof _parametros[parametro] === 'object') {
                    Object.keys(_parametros[parametro]).map(campo => {
                        _parametros[parametro + '['+campo+']'] = 
                            _parametros[parametro][campo]
                    })
                    delete _parametros[parametro]
                }
            })
            location.href = `${router.currentRoute.path}?` + new URLSearchParams(_parametros).toString()
        },
        
        async transmitir(id) {

            if(!this.verificaPermissao('conhecimentos/transmitir')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const modeloCertificado = Vue.prototype.$usuarioLogado.LojaConfiguracoes.modelo_certificado_digital
            if (modeloCertificado == '1') {
                await this.transmitirA1(id)
            } else {
                await this.transmitirA3(id)
            }
        },

        async transmitirA1(id) {
            this.showNotify('Enviando para SEFAZ...')
            const retorno = await CteService.transmitir(id);
            if (retorno.status == 200) {

                if(retorno.data.cStat == 100) {
                    Vue.prototype.$notify.close()
                    Vue.prototype.$notify.success('Conhecimento transmitido com sucesso!')
                }else{
                    Vue.prototype.$notify.close()
                    Vue.prototype.$dialog.error(`O documento de resposta relata um erro [${retorno.data.cStat}] ${retorno.data.xMotivo}`)
                }

                this.carregaDados();
                
            } else {
                Vue.prototype.$notify.close()
                Vue.prototype.$dialog.error(retorno.message)
            }
        },

        async transmitirA3(id) {
            Vue.prototype.$loading.show();
            this.showNotify('Processando CT-e...')
            const retXml = await CteService.buscarXmlTransmitirA3(id)
            if(retXml.status == 200) {
                this.showNotify('Enviando para SEFAZ...')
                let retA3;
                try{
                    retA3 = await A3Service.trasmitir({ 
                        xml: retXml.data.xml, 
                        eventoUrl: retXml.data.urls.evento,
                        qrCodeUrl: retXml.data.urls.qrcode
                    });
                } catch(e) {
                    Vue.prototype.$loading.hide();
                    Vue.prototype.$notify.close()
                    Vue.prototype.$dialog.error('O aplicativo desktop não está em execução!')
                }
                if (retA3.sucesso) {
                    this.showNotify('Atualizando status do CT-e...')
                    const retAutorizarCte  = await CteService.autorizarA3({ 
                        id: id, 
                        xmlAssinado: retA3.xmlAssinado, 
                        xmlRetorno: retA3.xmlRetorno
                    })
                    if (retAutorizarCte.status == 200) {
                        if(retAutorizarCte.data.cStat == 100) {
                            Vue.prototype.$loading.hide();
                            Vue.prototype.$notify.close()
                            Vue.prototype.$notify.success('Conhecimento transmitido com sucesso!')
                        }else{
                            Vue.prototype.$loading.hide();
                            Vue.prototype.$notify.close()
                            Vue.prototype.$dialog.error(`O documento de resposta relata um erro [${retAutorizarCte.data.cStat}] ${retAutorizarCte.data.xMotivo}`)
                        }
                        this.carregaDados();
                    } else {
                        Vue.prototype.$loading.hide();
                        Vue.prototype.$notify.close()
                        Vue.prototype.$dialog.error(retAutorizarCte.message)
                    }
                    
                }
            } else {
                Vue.prototype.$loading.hide();
                Vue.prototype.$notify.close()
                Vue.prototype.$dialog.error(retXml.message)
            }
        },

        async baixarXml(id) {

            if(!this.verificaPermissao('conhecimentos/baixar-xml')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const retorno = await CteService.baixarXml(id);
            if (retorno.status == 200) {
                const link = 'data:application/xml;base64,' + retorno.data.conteudo
                const download = document.createElement('a')
                const fileName = retorno.data.arquivo
                download.href = link
                download.download = fileName
                download.click()
                Vue.prototype.$dialog.success('Arquivo XML exportado com sucesso!')
            } else {
                Vue.prototype.$dialog.error(retorno.message)
            }
        },
        
        /* Compartilhar por whatsapp */
        async abreModalCompartilhaWhatsapp(id, fone) {

            if(!this.verificaPermissao('conhecimentos/compartilhar-whatsapp')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            let dominioCompleto = window.location.protocol + '//' + window.location.hostname;
            if (window.location.port)
                dominioCompleto += ':' + window.location.port;
            
            this.form.compartilhaWhatsapp.mensagem =  `${dominioCompleto}${Vue.prototype.$urlBase}/conhecimentos/dacte/${id}`
            this.form.compartilhaWhatsapp.celular = fone ?? ''
            await Vue.prototype.$modal.show(() => import('../components/Modals/CompartilhaWhatsapp.vue'), 'md')
        },

        async compartilhaWhatsapp() {
            const baseUrl = !isMobile() 
                ? 'https://web.whatsapp.com/send?phone=55' 
                : 'whatsapp://send?phone=55'
            
            const celular = this.form.compartilhaWhatsapp.celular.replace(/\D/g, "");
            const mensagem = this.form.compartilhaWhatsapp.mensagem

            const url = `${baseUrl}${celular}&text=${mensagem}`
            window.open(url, '_blank')
            setTimeout(() => {
                this.fechaModal()
            }, 500)
        },

        /* Enviar por email */
        async abreModalEnviaEmail(id, nCT, emailRecebedor) {

            if(!this.verificaPermissao('conhecimentos/enviar-email')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            let dominioCompleto = window.location.protocol + '//' + window.location.hostname;
            if (window.location.port)
                dominioCompleto += ':' + window.location.port;

            this.form.enviaEmail.assunto =  `Conhecimento de Transporte Eletrônico ${nCT}`
            this.form.enviaEmail.mensagem = 'Segue em anexo, o link do CT-e. Para abrir o documento basta clicar no link'
            this.form.enviaEmail.link = `${dominioCompleto}${Vue.prototype.$urlBase}/conhecimentos/dacte/${id}`
            this.form.enviaEmail.emails = emailRecebedor
            await Vue.prototype.$modal.show(() => import('../components/Modals/EnviaEmail.vue'), 'lg')
        },

        async enviaEmail() {
            const retorno = await CteService.enviaEmail(this.form.enviaEmail);
            if (retorno.status == 200) {
                Vue.prototype.$notify.success('Email enviado com sucesso!')
                setTimeout(() => {
                    this.fechaModal()
                }, 500)
            } else {
                Vue.prototype.$dialog.error(retorno.data)
            }
        },

        copiaLink (){         
            navigator.clipboard.writeText(this.form.enviaEmail.link)
            this.form.enviaEmail.linkTitle = 'Copiado!'
        },

        async exportarDados(pagina, hash = ''){

            if(!this.verificaPermissao('conhecimentos/exportar-xls')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            if (pagina == 1){
                Vue.prototype.$notify.default('Exportando...', 'Exportar XML...', { autoHideDelay: 100000 } )
            }

            const response = await CteService.exportarXml(pagina, hash, this.form.exportarXmls);

            if(response.status == 200) {

                if(!response.data.zip && response.data.current_page != response.data.last_page) {
                    
                    const mensagem = `Compactando, processo ${ response.data.current_page * response.data.per_page } de ${ response.data.total }`
                    Vue.prototype.$notify.default(mensagem, 'Exportar XML...', { autoHideDelay: 100000 } )
                    this.exportarDados((response.data.current_page + 1), response.data.hash);

                }else{

                    const mensagem = `${response.data.total} arquivos exportados de um total de ${response.data.total}`
                    Vue.prototype.$notify.default(mensagem, 'Exportar XML...', { autoHideDelay: 100000 } )
                    window.location = response.data.zip
                    Vue.prototype.$notify.close()
                    this.fechaModal()
                    Vue.prototype.$dialog.success('Arquivo exportado com sucesso!')
                }

            } else {

                this.fechaModal()
                Vue.prototype.$notify.close()
                Vue.prototype.$dialog.error(response.message ?? "Não foi possível exportar os arquivos xml's")
            }            
        },

        async abreModalCancelarConhecimento(id) {

            if(!this.verificaPermissao('conhecimentos/cancelar')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            this.form.cancelarConhecimento.motivo = '';
            this.form.cancelarConhecimento.id = id;
            await Vue.prototype.$modal.show(() => import('../components/Modals/CancelaConhecimento.vue'), 'md')
        },

        async cancelarConhecimento(){
            const modeloCertificado = Vue.prototype.$usuarioLogado.LojaConfiguracoes.modelo_certificado_digital
            if (modeloCertificado == '1') {
                await this.cancelarConhecimentoA1()
            } else {
                await this.cancelarConhecimentoA3()
            }
            
        },

        async cancelarConhecimentoA1(){
            const retorno = await CteService.cancelarConhecimento(this.form.cancelarConhecimento)

            if (retorno.status == 200) {
            
                this.fechaModal()
                this.carregaDados();                
                Vue.prototype.$dialog.success(`Conhecimentos cancelado com sucesso!`)
                
            } else {

                this.fechaModal()
                Vue.prototype.$dialog.error(retorno.message)
            }           
        },

        async cancelarConhecimentoA3(){
            Vue.prototype.$loading.show();
            this.showNotify('Processando CT-e...')
            const retXml = await CteService.buscarXmlCancelarA3(this.form.cancelarConhecimento)
            if(retXml.status == 200) {
                this.showNotify('Enviando para SEFAZ...')
                let retA3;
                try{
                    retA3 = await A3Service.cancelar({ 
                        xml: retXml.data.xml, 
                        eventoUrl: retXml.data.urls.evento,
                        qrCodeUrl: retXml.data.urls.qrcode
                    });
                } catch(e) {
                    this.fechaModal()
                    Vue.prototype.$loading.hide();
                    Vue.prototype.$notify.close()
                    Vue.prototype.$dialog.error('O aplicativo desktop não está em execução!')
                }
                if (retA3.sucesso) {
                    this.showNotify('Atualizando status do CT-e...')
                    const retAutorizarCte  = await CteService.cancelarA3({ 
                        id: this.form.cancelarConhecimento.id,
                        xmlRetorno: retA3.xmlRetorno
                    })
                    if (retAutorizarCte.status == 200) {
                        if(retAutorizarCte.data.cStat == 135 || retAutorizarCte.data.cStat == 101 ||  retAutorizarCte.data.cStat == 155) {
                            this.fechaModal()
                            Vue.prototype.$loading.hide();
                            Vue.prototype.$notify.close()
                            Vue.prototype.$notify.success('Conhecimento cancelado com sucesso!')
                        }else{
                            this.fechaModal()
                            Vue.prototype.$loading.hide();
                            Vue.prototype.$notify.close()
                            Vue.prototype.$dialog.error(`O documento de resposta relata um erro [${retAutorizarCte.data.cStat}] ${retAutorizarCte.data.xMotivo}`)
                        }
                        this.carregaDados();
                    } else {
                        this.fechaModal()
                        Vue.prototype.$loading.hide();
                        Vue.prototype.$notify.close()
                        Vue.prototype.$dialog.error(retAutorizarCte.message)
                    }
                   
                }
            } else {
                Vue.prototype.$loading.hide();
                Vue.prototype.$notify.close()
                Vue.prototype.$dialog.error(retXml.message)
            }
        },

        /* PAGAMENTO */
        async gerarFinanceiro() {          

            const payload = {
                id: this.controle.pagamento.inf.conhecimentoId,
                dadosPagamento: this.form.pagamento
            }
            const retorno = await CteService.gerarFinanceiro(payload)

            if (retorno.status == 200) {
                Vue.prototype.$notify.success(`Movimentação financeira gerada com sucesso!`)
                this.carregaDados(router.currentRoute)
                this.fechaModal()
            } else {
                Vue.prototype.$dialog.error(retorno.message)
                this.fechaModal()
            }
        },

        async abreModalPagamento(conhecimentoId, nCT, cliente, valor) {

            if(!this.verificaPermissao('conhecimentos/gerar-financeiro')){
                Vue.prototype.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            this.controle.pagamento.inf = {
                conhecimentoId: conhecimentoId,
                cliente: cliente,
                descricao: `CT-e de nº ${nCT}`,
                valor: valor
            }

            this.form.pagamento.valorTotal = valor;
            
            await Vue.prototype.$modal.show(() => import('../components/Modals/GerarFinanceiro.vue'), 'lg')
        },

        async carregaDadosPagamento() {
            const retorno = await ErpService.buscaFormasPagamentos();
            this.controle.pagamento.configPagamento.formasPagamento = retorno.data.map((item) => {
                return {
                    value: item.id,
                    text: item.nome
                }
            });

            this.controle.pagamento.condicoesPagamentos = [
                {
                  "value": "V",
                  "text": "À vista"
                },
                {
                  "value": "P",
                  "text": "Parcelado"
                }
            ];

            this.controle.pagamento.carregado = true;
        },

        preenchePagamento(pagamento) {
            
            if(!pagamento.opcaoPagamento) {
                this.form.pagamento.exibirPagamento = 0
            } else {
                if(pagamento.opcaoPagamento == 'P') {  
                    this.form.pagamento.exibirPagamento = 1 
                    this.form.pagamento.opcaoPagamento = pagamento.opcaoPagamento
                    this.form.pagamento.intervaloParcelas = pagamento.intervaloParcelas
                    this.form.pagamento.quantidadeParcelas = pagamento.quantidadeParcelas
                    this.form.pagamento.dataPrimeiraParcela = pagamento.dataPrimeiraParcela
                    this.form.pagamento.formaPagamentoId = pagamento.formaPagamentoId
                    this.preencheParcelas(pagamento.pagamentoParcela)
                } else if(pagamento.opcaoPagamento == 'V') {
                    this.form.pagamento.opcaoPagamento = pagamento.opcaoPagamento
                    this.preencheParcelas(pagamento.pagamentoParcela)
                }
            }
        },

        preencheParcelas(pagamentoParcela) {
            this.form.pagamento.pagamentoParcela = []
            pagamentoParcela.forEach(parcela => {
                this.form.pagamento.pagamentoParcela.push({
                    data_vencimento: parcela.dataVencimento,
                    valor: parcela.valor,
                    forma_pagamento_id: parcela.formaPagamentoId,
                    nome_forma_pagamento: parcela.nomeFormaPagamento,
                    categoria_id: parcela.categoriaId,
                    nome_categoria: parcela.nomeCategoria,
                    observacao: parcela.observacao
                })
            })
        },

        validaExibicaoPagamento() {
            this.form.pagamento.exibirPagamento = 1
        },

        carregaParcelas() {

            if (this.form.pagamento.pagamentoParcela.length) {
                this.form.pagamento.pagamentoParcela.map((parcela, i) => {
                    this.form.pagamento.pagamentoParcela[i].pedido_id = null
                    if (this.$route.query.orcamento && this.controle.pagamento.configPagamento.categoria.CategoriasMovimentacoesFinanceira.id) {
                        this.form.pagamento.pagamentoParcela[i].categoria_id = this.controle.pagamento.configPagamento.categoria.CategoriasMovimentacoesFinanceira.id
                        this.form.pagamento.pagamentoParcela[i].nome_categoria = this.controle.pagamento.configPagamento.categoria.CategoriasMovimentacoesFinanceira.nome
                    }
                })
            }
        },
        alteraTipoPagamento(tipo) {
            this.form.pagamento.quantidadeParcelas = ''
            if (tipo == 'V') {
                this.form.pagamento.quantidadeParcelas = 1
                this.geraParcelas()
            }
        },
        async alteraFormaPagamento(id) {
            const pagamento = this.form.pagamento
            pagamento.quantidadeParcelas = ''
            if (id) {
                const retorno = await ErpService.buscaFormaPagamento({
                    id: id,
                    valorTotal: removeMoeda(pagamento.valorTotal),
                    dataInicio: pagamento.data
                });
                if (retorno.status == 'success') {
                    this.controle.pagamento.configPagamento.maximoParcelas = retorno.data.maximo_parcelas
                    pagamento.intervaloParcelas = retorno.data.intervalo_parcelas
                    pagamento.dataPrimeiraParcela = retorno.data.data_primeira_parcela
                    pagamento.formaPagamentoNome = this.controle.pagamento.configPagamento.formasPagamento.filter(item => item.value == id)[0].text
                    this.controle.pagamento.quantidadeParcelas ='select'
                }
            }
        },
        atualizaFormaPagamento(formaPagamento, i) {
            const parcela = this.form.pagamento.pagamentoParcela[i]
            parcela.forma_pagamento_id = formaPagamento ? formaPagamento.id : ''
            parcela.nome_forma_pagamento = formaPagamento ? formaPagamento.nome : ''
        },
        async adicionarFormaPagamento(nome) {
            if (!this.controle.pagamento.configPagamento.permissaoCadastrarFormaPagamento) {
                Vue.prototype.$dialog.error('Você não possui permissão para cadastrar formas de pagamento!')
                return false
            }
            const retorno = await Vue.prototype.$modal.show(() => import('@/domains/shared/financeiro/auxiliares/formas_pagamentos/views/Adicionar'), 'lg', {
                urlApi: '/formas_pagamentos/adicionar',
                nome: nome
            })
            if (retorno && retorno.status == 'success') {
                const forma = { id: retorno.data, nome: retorno.request.FormasPagamento.nome }
                this.$refs['autoPagamento'][this.formaPagamentoAtual].selectedResult = forma
            }
        },
        carregaFormaPagamento(i) {
            if (this.form.pagamento.pagamentoParcela[i].nome_forma_pagamento) {
                return {
                    id: this.form.pagamento.pagamentoParcela[i].forma_pagamento_id || null,
                    nome: this.form.pagamento.pagamentoParcela[i].nome_forma_pagamento
                }
            } else {
                return null
            }
        },
        async adicionarCategoria(nome) {
            if (!this.controle.pagamento.configPagamento.permissaoCadastrarCategoria) {
                Vue.prototype.$dialog.error('Você não possui permissão para cadastrar planos de contas!')
                return false
            }
            await Vue.prototype.$modal.show(() => import('@/domains/shared/financeiro/auxiliares/plano_contas/views/Adicionar'), 'lg', {
                urlApi: '/categorias_movimentacoes_financeiras/adicionar',
                nome: nome
            })
        },
        atualizaCategoria(formaPagamento, i) {
            const parcela = this.form.pagamento.pagamentoParcela[i]
            if (formaPagamento) {
                parcela.categoria_id = formaPagamento ? formaPagamento.id : ''
                parcela.nome_categoria = formaPagamento ? formaPagamento.nome : ''
            } else {
                parcela.categoria_id = ''
                parcela.nome_categoria = ''
            }
        },
        carregaCategoria(i) {
            if (this.form.pagamento.pagamentoParcela[i].nome_categoria) {
                return {
                    id: this.form.pagamento.pagamentoParcela[i].categoria_id || null,
                    nome: this.form.pagamento.pagamentoParcela[i].nome_categoria
                }
            } else {
                return null
            }
        },
        async geraParcelas() {

            const pagamento = this.form.pagamento
            if (pagamento.quantidadeParcelas == '' || pagamento.quantidadeParcelas == 0) {
               Vue.prototype.$notify.error('Escolha a quantidade de parcelas!')
                return false
            }
            let nomeFormaPagamento = '';
            for(let i in this.controle.pagamento.configPagamento.formasPagamento) {
                if(this.controle.pagamento.configPagamento.formasPagamento[i].value == pagamento.formaPagamentoId) {
                    nomeFormaPagamento = this.controle.pagamento.configPagamento.formasPagamento[i].text;
                }
            }
            this.form.pagamento.pagamentoParcela = []
            const retorno = await ErpService.getParcelas({
                pagamento: pagamento.opcaoPagamento,
                formaPagamentoId: pagamento.formaPagamentoId || '',
                nomeFormaPagamento: nomeFormaPagamento,
                valorTotal: removeMoeda(pagamento.valorTotal),
                dataPrimeiraParcela: pagamento.dataPrimeiraParcela,
                intervaloDias: pagamento.intervaloParcelas,
                numeroParcelas: pagamento.quantidadeParcelas,
                tipo: 'C'
            });
            if (retorno.status == 'success') {
                retorno.data.parcelas.map((parcela) => {
                    this.adicionaParcela(parcela)
                })
            }
        },
        adicionaParcela(parcela = null) {
            this.form.pagamento.pagamentoParcela.push({
                data_vencimento: parcela ? parcela.data_vencimento : null,
                valor: parcela ? parcela.valor : null,
                forma_pagamento_id: parcela ? parcela.forma_pagamento_id : null,
                nome_forma_pagamento: parcela ? parcela.nome_forma_pagamento : null,
                categoria_id: this.controle.pagamento.configPagamento.categoria.CategoriasMovimentacoesFinanceira.id || null,
                nome_categoria: this.controle.pagamento.configPagamento.categoria.CategoriasMovimentacoesFinanceira.nome || null,
                observacao: ''
            })
        },
        removeParcela(i) {
            this.form.pagamento.pagamentoParcela.splice(i, 1)
        },
        alteraValorParcela(i) {
            setTimeout(() => {
                const valorTotal = removeMoeda(this.form.pagamento.valorTotal)
                let valorSugerido = removeMoeda(this.form.pagamento.pagamentoParcela[i].valor)
                let iParcelas = 0
                while (i > iParcelas) {
                    valorSugerido += removeMoeda(this.form.pagamento.pagamentoParcela[iParcelas].valor)
                    iParcelas++
                }
                let valorRestante = valorTotal - valorSugerido
                iParcelas = JSON.parse(JSON.stringify(i + 1))
                let qtdParcelas = this.form.pagamento.pagamentoParcela.length
                let valorParcela = valorRestante / (qtdParcelas - iParcelas)
                while (iParcelas < qtdParcelas) {
                    if (iParcelas + 1 == qtdParcelas) {
                        valorParcela = valorRestante
                    }
                    if (valorParcela < 0) {
                        valorParcela = 0
                    }
                    valorRestante = valorRestante - valorParcela.toFixed(2)
                    this.form.pagamento.pagamentoParcela[iParcelas].valor = formataMoeda(valorParcela)
                    iParcelas++
                }
            }, 100)
        },
        validaFormaParcelada() {
            if (this.form.pagamento.exibirPagamento == 1 && this.form.pagamento.opcaoPagamento == 'P' && this.form.pagamento.pagamentoParcela.length == 0) {
                Vue.prototype.$dialog.error('Você deve gerar as parcelas!')
                return false
            } else {
                return true
            }
        },

        fechaModal(){
            Vue.prototype.$modal.hide()
        },

        permiteEdicao(situacao) {
            if (situacao == 'Autorizado' || situacao == 'Cancelado') {
                return false
            }

            return true;
        },

        showNotify(mensagem) {
            Vue.prototype.$notify.close()
            Vue.prototype.$notify.default(
                mensagem, 
                'Processo em andamento',
                {
                    autoHideDelay: 100000,
                    noFade: true
                }
            )
        },

        urlRetornoFormatada() {
            return router.currentRoute.fullPath
                .replaceAll('&', '%26')
                .replaceAll('/', '%2F')
        }
    },
})
